module.exports = __webpack_public_path__ + "img/sterlizer.704831af.png";